/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Passkey_Not_SetupInputs */



/**
* | output |
* | --- |
* | "Not set up" |
*
* @param {Profile_Passkey_Not_SetupInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_passkey_not_setup = /** @type {((inputs?: Profile_Passkey_Not_SetupInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Passkey_Not_SetupInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Non configuré")
	if (locale === "es") return /** @type {LocalizedString} */ ("No configurado")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não configurado")
	if (locale === "it") return /** @type {LocalizedString} */ ("Non configurato")
	return /** @type {LocalizedString} */ ("Not set up")
});